<template>
  <div class="social social-box">
    <div :class="className">
      <i class="fa fa-dollar"></i>
      <h3 @click="showDetail">{{ balance }}</h3>
      <span>{{ accountName }}</span>
    </div>
  </div>
</template>
<style scoped>

</style>
<script>
export default {
  name: 'RevenueAccountBox',
  props: ['balance', 'type'],
  data: function() {
    return {
    }
  },
  computed: {
    className: function() {
      if (this.type === 1)
        return 'social-slick-4 google-plus-box'
      else if (this.type === 2)
        return 'social-slick-4 instagram-box'
      else if (this.type === 3)
        return 'social-slick-4 facebook-box'
      else
        return 'social-slick-4 twitter-box'
    },
    accountName: function() {
      if (this.type === 1)
        return this.$t('revenue.deposit')
      else if (this.type === 2)
        return this.$t('revenue.backout')
      else if (this.type === 3)
        return this.$t('revenue.non-operation')
      else if (this.type === 4)
        return this.$t('revenue.retained')
      else
        return this.$t('revenue.operation')
    }
  },
  methods: {
    showDetail: function() {
      this.$emit('show-detail', this.type)
    }
  },
  created: function() {
    //console.log(this.ba)
  }
}
</script>